import Swiper, { Pagination, Navigation} from "swiper";

Swiper.use([ Pagination, Navigation]);

export function initPlanSlider(){

    const mySwiper = new Swiper('#plan_slider', {
        loop: false,
        speed: 1000,
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-plan-next',
            prevEl: '.swiper-plan-prev',
        },
        breakpoints: {
            0: {
                navigation: {
                    nextEl: null,
                    prevEl: null,
                },
            },
            769: {
                navigation: {
                    nextEl: '.swiper-plan-next',
                    prevEl: '.swiper-plan-prev',
                }
            }
        },
    });
}

